import React, { useEffect, useRef } from "react";
import DOMPurify from "dompurify";
import api from "src/services/api";

function prepareCommentHtml(html) {
  const sanitizedHtml = DOMPurify.sanitize(html);
  const template = document.createElement("template");
  template.innerHTML = sanitizedHtml;

  const backendBaseUrl = new URL(
    api.defaults?.baseURL || window.location.origin,
    window.location.origin,
  );
  backendBaseUrl.pathname = `${backendBaseUrl.pathname.replace(/\/+$/, "")}/`;
  template.content
    .querySelectorAll('img[src^="/taiga-comment-image?"]')
    .forEach((image) => {
      const imagePath = image.getAttribute("src").replace(/^\/+/, "");
      image.src = new URL(imagePath, backendBaseUrl).href;
    });

  return template.innerHTML;
}

export default function TaigaCommentContent({ html, text }) {
  const contentRef = useRef(null);
  const sanitizedHtml =
    typeof html === "string" && html.trim()
      ? prepareCommentHtml(html)
      : null;

  useEffect(() => {
    const images = contentRef.current?.querySelectorAll("img") || [];
    const handleImageError = (event) => {
      event.currentTarget.hidden = true;
    };

    images.forEach((image) =>
      image.addEventListener("error", handleImageError),
    );

    return () => {
      images.forEach((image) =>
        image.removeEventListener("error", handleImageError),
      );
    };
  }, [sanitizedHtml]);

  if (sanitizedHtml) {
    return (
      <div
        ref={contentRef}
        className="kanban-comment-content"
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      />
    );
  }

  return (
    <div ref={contentRef} className="kanban-comment-content">
      {text || ""}
    </div>
  );
}
